import {EventEmitter} from "events";


export type AccessToken = {
    accessToken: string
    expiresAt: Date
}


export function getAccessTokenExpiresIn(accessToken: AccessToken) {
    if (!accessToken) {
        return 0;
    }
    return Math.max(0, (accessToken.expiresAt.getTime() - Date.now()) / 1000);
}


const ACCESS_TOKEN_STORAGE_KEY = "auth-token";
const em = new EventEmitter();
const CHANGE_ACCESS_TOKEN_EVENT = "change";
const EXPIRED_ACCESS_TOKEN_EVENT = "expired";


let cachedAccessToken: AccessToken = null;
let cachedAccessTokenTimeoutID = null;

function setCachedAccessTokenAndWatchExpired(accessToken: AccessToken) {
    cachedAccessToken = accessToken;
    clearTimeout(cachedAccessTokenTimeoutID);

    if (accessToken) {
        const expiresIn = getAccessTokenExpiresIn(accessToken);
        cachedAccessTokenTimeoutID = setTimeout(() => {
            em.emit(EXPIRED_ACCESS_TOKEN_EVENT);
        }, expiresIn * 1000);
    }
}

export function setAccessToken(accessToken: AccessToken) {
    // устанавливаем 5 секундный запас времени для токена
    accessToken = {
        ...accessToken,
        expiresAt: new Date(accessToken.expiresAt.getTime() - 5000)
    }

    localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, JSON.stringify({
        accessToken: accessToken.accessToken,
        expiresAt: accessToken.expiresAt.getTime(),
    }));
    setCachedAccessTokenAndWatchExpired(accessToken);
    em.emit(CHANGE_ACCESS_TOKEN_EVENT, accessToken);
}


export function getAccessToken() {
    if (!cachedAccessToken && typeof localStorage != "undefined") {
        try {
            const schema = [
                ["accessToken", "string"],
                ["expiresAt", "number"],
            ];
            const raw = JSON.parse(localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY));
            for (const [key, type] of schema) {
                if (!raw || typeof raw[key] != type) {
                    return null;
                }
            }
            setCachedAccessTokenAndWatchExpired({
                accessToken: raw.accessToken,
                expiresAt: new Date(raw.expiresAt),
            })
        } catch (e) {
            console.error("Read AccessToken from localStorage error", e);
        }
    }
    return cachedAccessToken;
}

export function delAccessToken() {
    if (getAccessToken()) {
        setCachedAccessTokenAndWatchExpired(null);
        localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
        em.emit(CHANGE_ACCESS_TOKEN_EVENT, null);
    }
}

export function onAccessTokenChanged(handler: (accessToken: AccessToken | null) => any) {
    em.addListener(CHANGE_ACCESS_TOKEN_EVENT, handler);
    return () => {
        em.removeListener(CHANGE_ACCESS_TOKEN_EVENT, handler);
    }
}

export function onAccessTokenExpired(handler: () => void) {
    em.addListener(EXPIRED_ACCESS_TOKEN_EVENT, handler);
    return () => {
        em.removeListener(EXPIRED_ACCESS_TOKEN_EVENT, handler);
    }
}